import React, { Component } from 'react';
import { Backdrop, Spinner } from 'components';
import { logger } from 'helpers';
import { CloseButton, PatientRefresh } from 'components/Icons';
import s from './style.module.scss';

const blockScroll = (nextProps, props) => {
	const body = document.querySelectorAll('body')[0];
	const rootEl = document.getElementById('root');

	if (nextProps.show && props.show !== nextProps.show) {
		body.style.overflow = 'hidden';

		if (rootEl && rootEl.offsetHeight > window.innerHeight)
			rootEl.style.overflow = 'scroll';
	} else if (!nextProps.show && props.show !== nextProps.show) {
		body.style.overflow = 'auto';

		if (rootEl && rootEl.offsetHeight > window.innerHeight)
			rootEl.style.overflow = 'auto';
	}
};

class ModalPopUp extends Component {
	componentDidUpdate(prevProps) {
		logger('[ModalPopUp] componentDidUpdate');

		blockScroll(this.props, prevProps);
	}

	render() {
		const wrapClasses = [s.wrapper, this.props.wrapClassName];
		const modalClasses = [s.modal, this.props.className];
		let modal = <Spinner className={s.spinner} />;
		let refresh;

		if (this.props.show) {
			wrapClasses.push(s.open);
		}

		if (this.props.modalRefresh) {
			refresh = (
				<PatientRefresh
					className={s.refreshBtn}
					onClick={this.props.modalRefresh}
				/>
			);
		}

		let additionalPlaceholder = null;
		if (this.props.additionalPlaceholder) {
			additionalPlaceholder = (
				<div className={s.additionalPlaceholder}>
					{this.props.additionalPlaceholder}
				</div>
			);
		}
		if (!this.props.loading) {
			modal = (
				<div className={modalClasses.join(' ')}>
					{!this.props.hideTitle && (
						<div className={s.modalWrappers}>
							<div className={s.Title}>
								{<span className={s.modalTitle}>{this.props.modalTitle}</span>}
							</div>
							{refresh}
							{additionalPlaceholder}
							{!this.props.restrictClosing ? (
								<CloseButton
									className={s.closeBtn}
									onClick={this.props.modalClosed}
								/>
							) : (
								''
							)}
						</div>
					)}
					{this.props.children}
				</div>
			);
		}

		return (
			<Backdrop
				show={this.props.show}
				clicked={
					!this.props.restrictClosing ? this.props.modalClosed : () => false
				}
			>
				{modal}
			</Backdrop>
		);
	}
}

ModalPopUp.defaultProps = {
	modalRefresh: false,
};

export default ModalPopUp;
